module.exports = __webpack_public_path__ + "static/media/notebook-arrow.599829d3.svg";